import ReusableIdsIdentityManager from './reusable-ids';

export default class ConnectVisitorContactIdentityManager extends ReusableIdsIdentityManager {}
